export interface AtelierType {
  value: string;
  label: string;
  description: string;
  icon: string;
}

export const ATELIER_TYPES: AtelierType[] = [
  { value: 'cv', label: 'Atelier CV', description: 'Rédaction et optimisation du CV', icon: 'FileText' },
  { value: 'lettre_motivation', label: 'Atelier Lettre de motivation', description: 'Rédaction de lettres de motivation personnalisées', icon: 'Mail' },
  { value: 'simulation_entretien', label: 'Atelier Présentation de soi (simulation d\'entretien)', description: 'Entraînement aux entretiens d\'embauche', icon: 'Users' },
  { value: 'recherche_emploi', label: 'Atelier Recherche d\'emploi', description: 'Techniques de recherche d\'emploi et candidatures', icon: 'Search' },
  { value: 'reseau', label: 'Atelier Réseau professionnel', description: 'Développement et exploitation du réseau professionnel', icon: 'Network' },
  { value: 'linkedin', label: 'Atelier LinkedIn', description: 'Optimisation du profil LinkedIn et présence en ligne', icon: 'Linkedin' },
  { value: 'orientation', label: 'Atelier Orientation professionnelle', description: 'Bilan de compétences et projet professionnel', icon: 'Compass' },
  { value: 'competences', label: 'Atelier Bilan de compétences', description: 'Identification et valorisation des compétences', icon: 'Award' },
  { value: 'numerique', label: 'Atelier Numérique', description: 'Maîtrise des outils numériques pour la recherche d\'emploi', icon: 'Monitor' },
  { value: 'confidence', label: 'Atelier Confiance en soi', description: 'Développement de la confiance et posture professionnelle', icon: 'Heart' },
  { value: 'pitch', label: 'Atelier Pitch professionnel', description: 'Construction et entraînement du pitch de présentation', icon: 'Mic' },
  { value: 'negociation', label: 'Atelier Négociation salariale', description: 'Techniques de négociation de rémunération', icon: 'Handshake' },
  { value: 'integration', label: 'Atelier Intégration entreprise', description: 'Préparation à l\'intégration et réussite en entreprise', icon: 'Building' },
  { value: 'mobility', label: 'Atelier Mobilité professionnelle', description: 'Géolocalisation et mobilité dans la recherche d\'emploi', icon: 'MapPin' },
  { value: 'entrepreneuriat', label: 'Atelier Entrepreneuriat', description: 'Création d\'entreprise et auto-entrepreneuriat', icon: 'Rocket' },
  { value: 'other', label: 'Autre atelier', description: 'Atelier sur mesure selon les besoins', icon: 'MoreHorizontal' },
];

export function getAtelierTypeLabel(value: string): string {
  return ATELIER_TYPES.find(t => t.value === value)?.label || 'Atelier';
}

export function getAtelierTypeDescription(value: string): string {
  return ATELIER_TYPES.find(t => t.value === value)?.description || '';
}
